module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.ca5c7073.png";